import React from 'react';
import { StyleProp, TextStyle } from 'react-native';
import { UseFormReturn } from 'react-hook-form';
import FilterDropdown from '../../Filter/components/FilterDropdown';
import FormDropDownPicker from '../../FormDropDownPicker';
import { translate } from '../../../services/translate';
import { permissionsValuesStructure } from '../../../pages/access/PermissionLevels/PermissionLevelForm';

type Props = {
    includeAllOption?: boolean;
    zIndex: number;
    disabled?: boolean;
    required?: boolean;
    labelFontSize?: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    label?: string;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: (keyof UserPermissions)[];
    setValue: React.Dispatch<React.SetStateAction<(keyof UserPermissions)[]>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function PermissionsLevelsDropdown({ form, fieldName, value, setValue, zIndex, disabled, required, labelFontSize = 16, labelStyle, viewStyle, label }: Props) {

    const selectablePermissions = permissionsValuesStructure
        .flat()
        .flatMap(({ title, values }) =>
            values.map(permission => ({
                value: permission.value as keyof UserPermissions,
                label: `${translate(title)} - ${translate(permission.label)}`,
            }))
        );

    if (form && fieldName) {
        return <FormDropDownPicker
            label={label ?? translate('permissionLevels')}
            items={selectablePermissions}
            multiple={true}
            zIndex={zIndex}
            disabled={disabled}
            required={required}
            fieldName={fieldName}
            form={form}
            labelFontSize={labelFontSize}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
            mode='BADGE'
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={label ?? translate('permissionLevels')}
                items={selectablePermissions}
                multiple={true}
                setValue={setValue}
                mode='BADGE'
                value={value}
                zIndex={zIndex}
                disabled={disabled}
                required={required}
                labelFontSize={labelFontSize}
                labelStyle={labelStyle}
                viewStyle={viewStyle}
            />
        );
    }
}

export default PermissionsLevelsDropdown;
